import React, { useEffect, useState, useRef } from "react";
import { object, array, string, bool, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { Link } from "@quintype/components";

import Carousel from "../../atoms/carousel";
import RightArrow from "../../atoms/icons/right-arrow";
import LeftArrow from "../../atoms/icons/left-arrow";
import ElectionIcon from "../../atoms/icons/election-icon";
import UpIcon from "../../atoms/icons/up-icon";
import DownIcon from "../../atoms/icons/down-icon";
import LiveIcon from "../../atoms/icons/live-icon";
import CloseIcon from "../../atoms/icons/close-icon";
import ElectionDownIcon from "../../atoms/icons/election-down-icon";

import { getStoryBySlug } from "../../helper/api";
import { setElectionData, setLiveBlogStory } from "../../helper/actions";

import "./election-widget.m.css";

const config = {
  apiKey: "AIzaSyD2loaJl1Hn9SjjCan6CaV9sXDFvopA1k4",
  authDomain: "dashboard-51ea4.firebaseapp.com",
  databaseURL: "https://dashboard-51ea4.firebaseio.com",
  projectId: "dashboard-51ea4",
  storageBucket: "dashboard-51ea4.appspot.com",
  messagingSenderId: "1062965330854",
};

const ResultsCard = ({ state, isHindi, showPrevResults }) => {
  const url = state.urls ? (isHindi ? state.urls.hi_url : state.urls.en_url) : "";

  let totalPartyCount = state.parties.reduce((a, i) => a + i.count, 0);
  // Below logic is only for west bengal since others is 1 so adding +1 for totalPartyCount to match with total count
  if (totalPartyCount === 291) {
    totalPartyCount = 292;
  }

  return (
    <Link styleName="card-wrapper" key={state.title} href={url}>
      <div styleName="item-details state">
        <span styleName="name">{isHindi ? state.title_hi : state.title}</span>
        <span styleName="seat-count">
          {totalPartyCount}/{state.total_seats}
        </span>
      </div>
      <div styleName="party-block">
        {state.parties.map((party) => {
          const prevCount = state.parties_prev.find((i) => i.id === party.id);
          let statusIcon = null;
          if (showPrevResults) {
            statusIcon =
              party.count !== prevCount.count ? party.count > prevCount.count ? <UpIcon /> : <DownIcon /> : null;
          }

          return (
            <div styleName="item-details party" key={party.id}>
              <span styleName={`party-name color-${party.category}`}>{party.name}</span>
              <div styleName="count-wrapper">
                <span styleName="party-count">
                  {party.count} {statusIcon}
                </span>
                {showPrevResults ? <span styleName="party-count prev">{prevCount.count}</span> : null}
              </div>
            </div>
          );
        })}
      </div>
    </Link>
  );
};

ResultsCard.propTypes = {
  state: object,
  isHindi: bool,
  showPrevResults: bool,
};

function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}

const Headlines = ({ titles }) => {
  const [text, setText] = useState();
  const [index, setIndex] = useState(0);

  useInterval(() => {
    const textIndex = index >= titles.length ? 0 : index;
    setIndex(textIndex + 1);
    setText(titles[textIndex]);
  }, 6000);

  return <span styleName="blinking">{text || ""}</span>;
};

Headlines.propTypes = {
  titles: array,
};

const ElectionWidgetBase = ({
  publisherName,
  setElectionData,
  setLiveBlogStory,
  electionData,
  liveBlogStory,
  showPrevResults,
}) => {
  const [isOpen, setIsopen] = useState(true);

  const isHindi = publisherName === "quint-hindi";

  const handleToggle = () => setIsopen(!isOpen);

  let firebaseApp = {};
  let firebaseDb = {};

  if (!firebase.apps.length) {
    firebaseApp = firebase.initializeApp(config);
    firebaseDb = firebaseApp.firestore();
    firebaseDb.settings({
      timestampsInSnapshots: true,
    });
  } else {
    firebaseApp = firebase.app();
    firebaseDb = firebaseApp.firestore();
  }

  const getElectiondata = (items) => {
    const data = [...items];
    const duplicateState = data.find((i) => i.s_no === 1) || data[0];
    data.push(duplicateState);
    // craete 2D array to match the designs.
    const stateResults2D = [];
    while (data.length) stateResults2D.push(data.splice(0, 2));
    return stateResults2D;
  };

  const getLiveBlogTitles = (story) => {
    return (
      story.cards &&
      story.cards
        .map((card) => {
          const titleEle = card["story-elements"].find(({ type }) => type === "title");
          return titleEle ? titleEle.text : "";
        })
        .filter((i) => i.length)
        .slice(0, 5)
    );
  };

  useEffect(() => {
    if (firebaseDb && !electionData.length) {
      firebaseDb.collection("Elections-2021").onSnapshot((res) => {
        const data = [];
        res.forEach((i) => data.push(i.data()));
        data.sort((a, b) => a.s_no - b.s_no);
        setElectionData(data);
      });
    }
  }, []);

  useEffect(() => {
    if (firebaseDb && !liveBlogStory) {
      firebaseDb.collection("Elections-2021-Urls").onSnapshot((res) => {
        const data = [];
        res.forEach((i) => data.push(i.data()));
        const url = isHindi ? "hi_url" : "en_url";
        const storyUrl = get(data, ["0", "urls", url], "");
        const showComparison = get(data, ["1", "comparison", "show"]);
        getStoryBySlug(storyUrl).then((res) =>
          setLiveBlogStory({
            story: res.story,
            showPrevResults: showComparison === "yes",
          })
        );
      });
    }
  }, []);

  const results = electionData.length ? getElectiondata(electionData) : [];
  const liveBlogTitles = liveBlogStory ? getLiveBlogTitles(liveBlogStory) : [];

  if (!results.length || !liveBlogTitles.length) return null;

  return (
    <div className="container" styleName="election-wrapper">
      <div styleName="widget-header" onClick={handleToggle}>
        <div styleName="widget-image">
          <ElectionIcon />
        </div>
        <div styleName="widget-title">
          <div styleName="title">
            <h2>{isHindi ? "विधानसभा चुनाव 2021: नतीजे" : "ASSEMBLY ELECTIONS 2021"}</h2>
            <h2 styleName="live">
              <LiveIcon />
              Live
              {isOpen ? <CloseIcon /> : <ElectionDownIcon />}
            </h2>
          </div>
          <p styleName="sub-headline">
            <Link href={`/${liveBlogStory.slug}`}>
              <Headlines titles={liveBlogTitles} />
            </Link>
          </p>
        </div>
      </div>
      <div styleName={`widget-body ${isOpen ? "active" : ""}`}>
        <Carousel
          carouselName="election-widget-slider"
          options={{
            type: "carousel",
            autoplay: 5000,
            hoverpause: true,
            perView: 1,
            perTouch: 1,
            breakpoints: {
              600: {
                perView: 1.1,
                perTouch: 1,
              },
            },
          }}
          totalItems={results.length}
          leftArrow={<LeftArrow />}
          rightArrow={<RightArrow />}
          showBullets={false}
          disableButtom={false}
        >
          {results.map((state, index) => {
            return (
              <div styleName="two-d-wrapper" key={index}>
                {state.map((i) => (
                  <ResultsCard key={state.title} state={i} isHindi={isHindi} showPrevResults={showPrevResults} />
                ))}
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

ElectionWidgetBase.propTypes = {
  titles: array,
  publisherName: string,
  setElectionData: func,
  setLiveBlogStory: func,
  electionData: array,
  liveBlogStory: object,
  showPrevResults: bool,
};

const mapStateToProps = (state) => {
  return {
    electionData: get(state, ["electionReducer", "states"], []),
    liveBlogStory: get(state, ["electionReducer", "liveBlogStory"], {}),
    showPrevResults: get(state, ["electionReducer", "showPrevResults"], false),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setElectionData: (data) => dispatch(setElectionData(data)),
  setLiveBlogStory: (data) => dispatch(setLiveBlogStory(data)),
});

const ElectionWidget = connect(mapStateToProps, mapDispatchToProps)(ElectionWidgetBase);

export default ElectionWidget;
